<template>
    <div class="about">
        <v-header/>
        <v-sidebar/>
        <div class="content-box">
            <div class="content">
                <div>
                    <div class="crumbs">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item>
                                <i class="el-icon-paperclip"></i> {{query.type=='forum'?'板块':'群组'}}管理
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <div class="container">
                        <div class="handle-box">
                            <el-input v-model="query.name" placeholder="名称" class="handle-input mr10"></el-input>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                            <el-button type="danger" icon="el-icon-plus" @click="handleAdd">添加</el-button>
                        </div>
                        <el-table :data="tableData" border class="table" ref="multipleTable"
                                  header-cell-class-name="table-header"   size="mini">
                            <el-table-column prop="id" label="ID" width="55" align="center" fixed="left"></el-table-column>

                            <el-table-column prop="name" label="名称" align="center"  width="100" fixed="left">
                                <template #default="scope">
                                    <router-link :to="'Forum?typeId='+scope.row.id" target="_blank">{{scope.row.name}}</router-link>
                                </template>
                            </el-table-column>
                            <el-table-column label="图标" align="center">
                                <template #default="scope">
                                    <img    @click="handleUpIcon(scope.$index, scope.row)" :src="scope.row.icon" style="width:70px;">
                                </template>
                            </el-table-column>
                            <el-table-column prop="tsort" label="排序字段" align="center"></el-table-column>
                            <el-table-column prop="tdesc" label="描述" width="200" align="center"></el-table-column>
                            <el-table-column :label="query.type=='forum'?'调研组员':'副群主'" width="200" align="center">
                                <template #default="scope">
                                    <div  @click="handleSetManager(scope.$index, scope.row)">
                                    <el-tag v-for="(t2,i2) in scope.row.utli">{{t2.uname}}</el-tag>
                                    </div>
                                </template>
                            </el-table-column>
<!--                            <el-table-column label="群成员" v-if="query.type=='sub'" width="200" align="center">-->
<!--                                <template #default="scope">-->
<!--                                    <div  @click="handleSetManager(scope.$index, scope.row)">-->
<!--                                        <el-tag v-for="(t2,i2) in scope.row.ptli">{{t2.uname}}</el-tag>-->
<!--                                    </div>-->
<!--                                </template>-->
<!--                            </el-table-column>-->
                            <el-table-column :label="query.type=='sub'?'加入方式':''" v-if="" width="200" align="center">
                                <template #default="scope">
                                    <p v-if="scope.row.addType=='1'">成员邀请审核</p>
                                    <p v-if="scope.row.addType=='2'" >副群主邀请审核</p>

                                </template>
                            </el-table-column>



                            <el-table-column label="权限" align="center"  v-if="query.type=='forum'" >
                            <el-table-column prop="releaseRolesName" label="发帖权限" align="center"  width="200"  v-if="query.type=='forum'"></el-table-column>
                            <el-table-column prop="replayRolesName" label="评论权限" align="center"  width="200"  v-if="query.type=='forum'"></el-table-column>
                            <el-table-column prop="seeRolesName" label="浏览权限" align="center"  width="200"  v-if="query.type=='forum'"></el-table-column>
                            </el-table-column>
                            <el-table-column prop="createrUname" :label="query.type=='forum'?'创建者':'群主'" align="center"></el-table-column>
                            <el-table-column prop="cts" label="创建时间" align="center" width="180"></el-table-column>

                            <el-table-column label="操作" width="120" align="center" fixed="right">
                                <template #default="scope">


                                    <el-dropdown>
                                        <el-button type="primary">
                                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item>
                                                <el-button type="text" icon="el-icon-edit"
                                                           @click="handleEdit(scope.$index, scope.row)">编辑
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <el-button type="text" icon="el-icon-picture-outline"
                                                           @click="handleUpIcon(scope.$index, scope.row)">上传图标
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <el-button type="text" icon="el-icon-user-solid"
                                                           @click="handleSetManager(scope.$index, scope.row)">{{scope.row.type=='forum'?'设置调研组员':'成员管理'}}
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <el-button type="text" icon="el-icon-circle-check"
                                                           @click="handleAgreeManager(scope.$index, scope.row)"> 成员审核
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <el-button type="text" icon="el-icon-delete" class="red"
                                                           @click="handleDelete(scope.$index, scope.row)">删除
                                                </el-button>
                                            </el-dropdown-item>

                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                    background
                                    @size-change="handleSizeChange"
                                    @current-change="handlePageChange"
                                    :current-page="query.pageNo"
                                    :page-sizes="[10,20,30]"
                                    :page-size="query.pageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="pageTotal">
                            </el-pagination>

                        </div>
                    </div>

                    <!-- 添加或者编辑弹出框 -->
                    <el-dialog :title="'添加或编辑-'+ (dataForm.name!=undefined?dataForm.name:'')" :visible.sync="editVisible">
                        <el-form
                                label-width="120px"
                                :model="dataForm"
                                :rules="dataFormRule"
                                ref="dataForm"
                        >
                            <el-form-item label="名称" prop="name">
                                <el-input v-model="dataForm.name"></el-input>
                            </el-form-item>
                            <el-form-item label="描述" prop="tdesc">
                                <el-input v-model="dataForm.tdesc" type="textarea"></el-input>
                            </el-form-item>
                            <el-form-item label="排序" prop="tsort">
                                <el-input v-model="dataForm.tsort" type="number"></el-input>
                                <p>越小越靠前</p>
                            </el-form-item>
                            <el-form-item label="加群方式" prop="addType"  v-if="query.type=='sub'">
                                <el-radio v-model="dataForm.addType"  label="1">成员邀请审核</el-radio>
                                <el-radio v-model="dataForm.addType"  label="2">副群主邀请审核</el-radio>
                            </el-form-item>
                            <el-form-item label="发帖权限" v-if="query.type=='forum'">
                                <el-checkbox-group v-model="releaseRoles">
                                    <el-checkbox label="管理员" ></el-checkbox>
                                    <el-checkbox label="调研组员" ></el-checkbox>
                                    <el-checkbox label="收集成员" ></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="评论权限" v-if="query.type=='forum'" >
                                <el-checkbox-group v-model="replayRoles">
                                    <el-checkbox label="管理员" ></el-checkbox>
                                    <el-checkbox label="调研组员" ></el-checkbox>
                                    <el-checkbox label="收集成员" ></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="浏览权限" v-if="query.type=='forum'" >
                                <el-checkbox-group v-model="seeRoles">
                                    <el-checkbox label="管理员" ></el-checkbox>
                                    <el-checkbox label="调研组员" ></el-checkbox>
                                    <el-checkbox label="收集成员" ></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>

                        </el-form>

                        <template #footer>
                                <span class="dialog-footer">
                                    <el-button @click="editVisible = false">取 消</el-button>
                                    <el-button type="primary" @click="saveEdit">确 定</el-button>
                                </span>
                        </template>
                    </el-dialog>


                    <!-- 上传图标 -->
                    <el-dialog :title="'上传图标-'+iconShowData.name" :visible.sync="icontVisible" style="text-align: center;">
                        <el-upload

                                drag
                                :before-upload="beforeUploadFile"
                                :show-file-list="false"
                                :action=FILE_ACTION
                                :on-success="handleFileSuccess"
                                accept="image/*"
                                :data="icondata"
                                :multiple="false">

                            <img :src="iconShowData.icon">
                            <p>支持拖拽上传</p>
                        </el-upload>
                        <template #footer>
                                <span class="dialog-footer">
                                    <el-button @click="icontVisible = false">取 消</el-button>
                                </span>
                        </template>
                    </el-dialog>


                    <!-- 添加或者编辑弹出框 -->
                    <el-dialog width="100%" :title="'设置'+(query.type=='forum'?'调研组员-':'副群主和成员-')+ (managerForm.name!=undefined?managerForm.name:'')" :visible.sync="managerVisible">
                        <el-row>

                            <el-col :span="serachManagerShow?14:6">
                                <el-card class="box-card">
                                    <div slot="header" class="clearfix">
                                        <span>搜索用户</span>
                                        <el-button @click="serachManagerShow=!serachManagerShow" style="float: right;" size="mini" icon="el-icon-plus" type="danger">添加{{query.type=='forum'?'调研组员':'副群主和成员'}}</el-button>
                                    </div>
                                    <div v-if="serachManagerShow">
                                        <div class="handle-box">
                                            <el-input v-model="managerQuery.unameLike" placeholder="用户名" class="handle-input mr10"></el-input>
                                            <el-input v-model="managerQuery.id" placeholder="用户id" class="handle-input mr10"></el-input>

                                            <el-input v-model="managerQuery.rnameLike" placeholder="姓名" class="handle-input mr10"></el-input>
                                            <el-input v-model="managerQuery.mobileLike" placeholder="手机号" class="handle-input mr10"></el-input>
                                            <el-input v-model="managerQuery.emailLike" placeholder="邮箱" class="handle-input mr10"></el-input>

                                            <el-button type="primary" icon="el-icon-search" @click="handleSearchManager">搜索</el-button>
                                            <el-button type="danger" icon="el-icon-delete" @click="handleSearchManagerClear">清空搜索条件</el-button>

                                        </div>
                                        <div>
                                        <el-table :data="managerUli" border class="table"   header-cell-class-name="table-header"  >
                                            <el-table-column prop="id" label="ID" width="55" align="center" fixed="left"></el-table-column>
                                            <el-table-column prop="uname" label="用户名"  align="center" width="120"   fixed="left" ></el-table-column>
                                            <el-table-column label="邮箱" width="300" align="center">
                                                <template #default="scope">
                                                    {{scope.row.email}}<el-tag v-if="scope.row.emailVaild!=null&&scope.row.emailVaild=='1'" type="danger"> 已验证 </el-tag>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="手机号" width="300" align="center">
                                                <template #default="scope">
                                                    <el-tag> {{scope.row.countryMobile}} {{scope.row.quhaoMobile}}</el-tag>{{scope.row.mobile}}
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="角色" width="100" align="center">
                                                <template #default="scope">

                                                    <p v-if="scope.row.role=='100'"><el-tag type="success">管理员</el-tag></p>
                                                    <p v-if="scope.row.role=='50'"><el-tag type="primary">调研组员</el-tag></p>
                                                    <p v-if="scope.row.role=='1'"><el-tag type="warning">收集成员</el-tag></p>
                                                    <p v-if="scope.row.role=='0'"><el-tag type="info">待验证</el-tag></p>
                                                    <p v-if="scope.row.role=='-1'">
                                                        <el-tooltip class="item" effect="dark" :content="'禁止原因：'+scope.row.shMsg" placement="top-start">
                                                            <el-tag type="danger">禁止访问</el-tag>
                                                        </el-tooltip>
                                                    </p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="状态" width="100" align="center">
                                                <template #default="scope">
                                                    <p v-if="scope.row.state=='1'"><el-tag type="success">正常</el-tag></p>
                                                    <p v-else>
                                                        <el-tooltip class="item" effect="dark" :content="'期限：'+scope.row.gagStart+' 到 '+scope.row.gagEnd" placement="top-start">
                                                            <el-tag type="danger">禁言</el-tag>
                                                        </el-tooltip>
                                                    </p>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="操作" width="250" align="center" fixed="right">
                                                <template #default="scope">
                                                    <el-button  type="primary" icon="el-icon-check" size="mini" @click="handleChooseManager(scope.$index, scope.row,'')" v-if="query.type=='forum'">设置调研组员</el-button>
                                                    <el-button  type="primary" icon="el-icon-check" size="mini" @click="handleChooseManager(scope.$index, scope.row,50)" v-if="query.type=='sub'">设置副群主</el-button>
                                                    <el-button  type="primary" icon="el-icon-check" size="mini" @click="handleChooseManager(scope.$index, scope.row,1)" v-if="query.type=='sub'">设置成员</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        </div>
                                        <div class="pagination">
                                            <el-pagination
                                                    background
                                                    @size-change="handleManagerSizeChange"
                                                    @current-change="handleManagerPageChange"
                                                    :current-page="managerQuery.pageNo"
                                                    :page-sizes="[10,20,30]"
                                                    :page-size="managerQuery.pageSize"
                                                    layout="total, sizes, prev, pager, next, jumper"
                                                    :total="managerPageTotal">
                                            </el-pagination>
                                        </div>
                                    </div>
                                </el-card>
                            </el-col>

                            <el-col :span="serachManagerShow?10:18">
                                <el-card class="box-card">
                                    <div slot="header" class="clearfix">
                                        <span>{{query.type=='forum'?'调研组员':'群组成员'}}信息</span>
                                    </div>
                                    <div class="handle-box">
                                        <el-input v-model="utQuery.unameLike" placeholder="用户名" class="handle-input mr10"></el-input>
                                        <el-select v-model="utQuery.teamRole" v-if="query.type=='sub'">
                                            <el-option value="" label="全部"></el-option>
                                            <el-option value="1" label="成员"></el-option>
                                            <el-option value="50" label="副群主"></el-option>
                                            <el-option value="100" label="群主"></el-option>
                                        </el-select>
                                        <el-button type="primary" icon="el-icon-search" @click="handleSearchUt">搜索</el-button>

                                    </div>
                                    <el-table :data="utli" border class="table"   header-cell-class-name="table-header">
                                        <el-table-column prop="manageUid" label="UID" width="55" align="center" ></el-table-column>
                                        <el-table-column prop="uname" label="用户名"  align="center"   ></el-table-column>
                                        <el-table-column   label="角色" v-if="query.type=='sub'"  align="center"   >
                                            <template #default="scope">
                                                <el-tag type="danger" v-if="scope.row.teamRole==100">群主</el-tag>
                                                <el-tag type="danger" v-if="scope.row.teamRole==50">副群主</el-tag>
                                                <el-tag  v-if="scope.row.teamRole==1">成员</el-tag>
                                            </template>
                                        </el-table-column>
                                        <el-table-column   label="加入时间" prop="cts"   align="center"  width="180" ></el-table-column>
                                        <el-table-column label="操作"  align="center" fixed="right" width="250">
                                            <template #default="scope">
                                                <el-popconfirm  placement="top" title="确定删除吗？"  v-if="scope.row.teamRole==1"  @confirm="handleDelManager(scope.$index, scope.row)"  size="small">
                                                <el-button  type="danger" icon="el-icon-delete"  slot="reference" size="mini">移除</el-button>
                                                </el-popconfirm>


                                                <el-button  type="primary" icon="el-icon-check" size="mini" @click="handleChooseManager2(scope.$index, scope.row,50)" v-if="query.type=='sub'&&scope.row.teamRole==1">设置副群主</el-button>
                                                <el-button  type="primary" icon="el-icon-check" size="mini" @click="handleChooseManager2(scope.$index, scope.row,1)" v-if="query.type=='sub'&&scope.row.teamRole==50">设置成员</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div class="pagination">
                                        <el-pagination
                                                background
                                                @size-change="handleUtSizeChange"
                                                @current-change="handleUtPageChange"
                                                :current-page="managerQuery.pageNo"
                                                :page-sizes="[10,20,30]"
                                                :page-size="managerQuery.pageSize"
                                                layout="total, sizes, prev, pager, next, jumper"
                                                :total="utTotal">
                                        </el-pagination>
                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>





                            <template #footer>
                                <span class="dialog-footer">
                                    <el-button @click="managerVisible = false">取 消</el-button>
                                </span>
                        </template>
                    </el-dialog>


                    <!--成员审核 -->
                    <el-dialog :title="'成员审核-'+cyshForm.name" :visible.sync="cyshVisible" style="text-align: center;">
                        <el-table :data="cyshData" border class="table"   header-cell-class-name="table-header"   size="mini">
                            <el-table-column  label="头像" width="55" align="center" >
                                <template  #default="scope">
                                    <img :src="scope.row.faceimg" style="width: 30px;height:30px;border-radius: 50%;">
                                </template>
                            </el-table-column>
                            <el-table-column  label="昵称"   align="center" >
                                <template  #default="scope">
                                   {{scope.row.uname}}
                                </template>
                            </el-table-column>
                            <el-table-column  prop="cts" label="创建时间" width="180" align="center" >   </el-table-column>
                            <el-table-column  label="操作"   align="center" width="200px" fixed="right">
                                <template  #default="scope">
                                    <el-button type="primary" @click="cyshAgreeOrNotHandle(scope.$index, scope.row,'1')" size="mini">同意进群</el-button>
                                    <el-button type="danger" @click="cyshAgreeOrNotHandle(scope.$index, scope.row,'-1')" size="mini">拒绝进群</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                    background
                                    @size-change="handleCyshSizeChange"
                                    @current-change="handleCyshPageChange"
                                    :current-page="cyshQuery.pageNo"
                                    :page-sizes="[10,20,30]"
                                    :page-size="cyshQuery.pageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="cyshTotalPage">
                            </el-pagination>
                        </div>
                        <template #footer>
                                <span class="dialog-footer">
                                    <el-button @click="cyshVisible = false">取 消</el-button>
                                </span>
                        </template>
                    </el-dialog>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vHeader from "./Header.vue";
    import vSidebar from "./Sidebar.vue";
    import {admin_type_page, admin_type_save, admin_type_del, admin_users_page2,
        admin_type_users_save,admin_type_users_del,admin_getUTPage,admin_ut_agreeOrNot} from '../../api';
    import {dealResult} from "../../api/common";

    export default {
        name: "AdminType",
        components: {
            vHeader,
            vSidebar,
        },
        data() {
            return {
                cyshForm:{},
                cyshVisible:false,
                cyshData:[],
                cyshQuery:{
                    pageNo:1,
                    pageSize:10,
                },
                cyshTotalPage:0,


                FILE_ACTION:'',
                icontVisible: false,
                icondata:{},
                iconShowData:{},



                tableData: [],
                query: {
                    name: '',
                    pageNo: 1,
                    pageSize: 10,
                    type:'',
                },
                pageTotal: 0,
                editVisible: false,

                releaseRoles:['管理员'],
                replayRoles:['管理员'],
                seeRoles:['管理员','调研组员','收集成员'],

                dataForm: {
                    id: '',
                    name: '',
                    tsort: '',
                    tdesc: '',
                    addType:'',

                },
                dataFormRule: {
                    name: [{required: true, message: '不能为空', trigger: 'blur'}],
                    tsort: [{required: true, message: '不能为空', trigger: 'blur'}],
                },
                lander: {},

                managerIndex:-1,
                managerForm:{},
                managerVisible: false,
                managerQuery: {
                    id: '',
                    unameLike: '',
                    mobileLike: '',
                    rnameLike: '',
                    emailLike: '',
                    selectType:'role_1_or_50',
                    pageNo:1,
                    pageSize:10
                },
                managerUli:[],
                managerPageTotal: 0,
                serachManagerShow:false,

                utQuery: {
                    unameLike:'',
                    teamRole:'',
                    pageNo:1,
                    pageSize:10
                },
                utli:[],
                utTotal:0,

            };
        },
        methods: {
            //删除调研组员
            handleDelManager(index,row){
                let o={
                    uid:this.lander.uid,
                    token:this.lander.token,
                    id:row.id,
                };
                admin_type_users_del(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success("已删除")
                        this.getPage();

                    }else this.$message.error(res.data.msg)

                })
            },
            //选择调研组员
            handleChooseManager(index,row,tro){
                let o={
                    uid:this.lander.uid,
                    token:this.lander.token,
                    manageUid:row.id,
                    typeId:this.managerForm.id,
                    teamRole:tro,
                };
                admin_type_users_save(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success("设置成功")
                        this.getPage();

                    }else this.$message.error(res.data.msg)

                })
            },
            //选择调研组员
            handleChooseManager2(index,row,tro){
                let o={
                    uid:this.lander.uid,
                    token:this.lander.token,
                    manageUid:row.manageUid,
                    typeId:this.managerForm.id,
                    teamRole:tro,
                };
                admin_type_users_save(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success("设置成功")
                        this.getPage();

                    }else this.$message.error(res.data.msg)

                })
            },
            handleManagerSizeChange(val) {
                this.managerQuery.pageNo = 1;
                this.managerQuery.pageSize = val;
                this.getUserPage();
            },
            // 分页导航
            handleManagerPageChange (val) {
                this.managerQuery.pageNo = val;
                this.getUserPage();
            },
            handleSearchManagerClear(){
                this.managerQuery.id='';
                this.managerQuery.unameLike='';
                this.managerQuery.mobileLike='';
                this.managerQuery.rnameLike='';
                this.managerQuery.emailLike='';
                this.managerQuery.pageNo=1;
                this.getUserPage();
            },
            handleSearchManager(){
                this.managerQuery.pageNo=1;
                this.getUserPage();
            },


            handleSearchUt(){
                this.utQuery.pageNo=1;
                this.getUTPage()
            },
            handleUtSizeChange(val) {
                this.utQuery.pageNo = 1;
                this.utQuery.pageSize = val;
                this.getUTPage();
            },
            // 分页导航
            handleUtPageChange (val) {
                this.utQuery.pageNo = val;
                this.getUTPage();
            },

            //获取用户列表数据
            getUserPage(){
                if(this.query.type=='forum')this.managerQuery.selectType='role_1_or_50';
                else this.managerQuery.selectType='role_1_or_50_or_100';

                this.managerQuery.uid = this.lander.uid;
                this.managerQuery.token = this.lander.token;
                admin_users_page2(this.managerQuery).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.managerUli = res.data.obj.list
                        this.managerPageTotal = res.data.obj.total//该页总共多少条记录
                    }

                })
            },
            beforeUploadFile(file){
                const isLt2M = file.size / 1024 / 1024 < 10;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 10 MB!');
                    return isLt2M;
                }

                this.loading = this.$loading({
                    lock: true,
                    text: "上传中，请稍等,,,,",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
            },
            handleFileSuccess(res) {
                this.loading.close();
                dealResult(res);
                if( res.status==1){

                    this.$message.success( '上传成功' );
                    this.icontVisible=false;
                    this.managerIndex=-1;
                    this.getPage();


                }else{
                    this.$message.error(res.msg);
                }

            },
            handleAgreeManager(index, row){
                this.cyshForm=row;
                this.cyshVisible=true;

                this.cyshQuery.pageNo=1;
                this.cyshData=[];
                this.getWaitAgreeCyFunc();
            },
            getWaitAgreeCyFunc(){
                this.cyshQuery.typeId=this.cyshForm.id;
                this.cyshQuery.isAgree='0';
                this.cyshQuery.uid=this.lander.uid;
                this.cyshQuery.token=this.lander.token;
                admin_getUTPage(this.cyshQuery).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.cyshData=res.data.obj.list;
                        this.cyshTotalPage=res.data.obj.total;
                    }else{
                        this.$message.error(res.data.msg);
                    }

                })
            },
            cyshAgreeOrNotHandle( index, row,isAgree){
                let o={id:row.id,isAgree:isAgree,uid:this.lander.uid,token:this.lander.token};
               admin_ut_agreeOrNot(o).then((res) => {
                   dealResult(res.data);
                   if (res.data.status == 1) {
                       this.$message.success(res.data.msg);
                       this.getWaitAgreeCyFunc();
                   }else{
                       this.$message.error(res.data.msg);
                   }

               })
            },
            handleCyshSizeChange(val) {
                this.cyshQuery.pageNo = 1;
                this.cyshQuery.pageSize = val;
                this.getWaitAgreeCyFunc()
            },
            // 分页导航
            handleCyshPageChange (val) {
                this.cyshQuery.pageNo = val;
                this.getWaitAgreeCyFunc();
            },
            handleSetManager( index, row){
                this.managerForm=row;

                this.managerVisible=true;
                this.managerIndex=index;

                this.getUserPage();

                this.utQuery.unameLike='';
                this.utQuery.teamRole='';
                this.getUTPage();
            },
            handleUpIcon( index,row){
                this.icondata={id:row.id};
                this.icontVisible=true;
                this.iconShowData.name=row.name;
                this.iconShowData.icon=row.icon;
            },
            // 查询操作
            handleSearch() {

                this.query.pageNo = 1;
                this.getPage();
            },

            // 分页导航
            handlePageChange(val) {
                this.query.pageNo = val;
                this.getPage();
            },
            handleSizeChange(val) {
                this.query.pageNo = 1;
                this.query.pageSize = val;
                this.getPage();
            },

            //弹出添加操作弹框
            handleAdd() {
                if(this.query.type=='forum') this.dataForm = {};
                else  this.dataForm.addType='1';
                this.editVisible = true;
            },
            //弹出修改操作弹框
            handleEdit(index, row) {
                this.dataForm.id = row.id
                this.dataForm.name = row.name
                this.dataForm.tsort = row.tsort
                this.dataForm.tdesc = row.tdesc
                this.dataForm.addType = row.addType
                this.editVisible = true;

                this.releaseRoles=[];
                if(row.releaseRoles!=null&&row.releaseRoles.length>0){
                    if(row.releaseRoles.indexOf("[100]")>-1) this.releaseRoles.push("管理员");
                    if(row.releaseRoles.indexOf("[50]")>-1) this.releaseRoles.push("调研组员");
                    if(row.releaseRoles.indexOf("[1]")>-1) this.releaseRoles.push("收集成员");
                }

                this.replayRoles=[];
                if(row.replayRoles!=null&&row.replayRoles.length>0){
                    if(row.replayRoles.indexOf("[100]")>-1) this.replayRoles.push("管理员");
                    if(row.replayRoles.indexOf("[50]")>-1) this.replayRoles.push("调研组员");
                    if(row.replayRoles.indexOf("[1]")>-1) this.replayRoles.push("收集成员");
                }


                this.seeRoles=[];
                if(row.seeRoles!=null&&row.seeRoles.length>0){
                    if(row.seeRoles.indexOf("[100]")>-1) this.seeRoles.push("管理员");
                    if(row.seeRoles.indexOf("[50]")>-1) this.seeRoles.push("调研组员");
                    if(row.seeRoles.indexOf("[1]")>-1) this.seeRoles.push("收集成员");
                }
            },
            //保存操作
            saveEdit() {
                this.$refs.dataForm.validate(valid => {
                    //表单验证失败
                    if (!valid) {
                        //提示语
                        this.$message.error("请按提示填写表单");
                        return false;
                    } else {
                        this.dataForm.uid = this.lander.uid;
                        this.dataForm.token = this.lander.token;
                        this.dataForm.type=this.query.type;

                        let releaseRoles="";
                        if(this.releaseRoles.length>0){
                            for(let i=0;i<this.releaseRoles.length;i++){
                                if(this.releaseRoles[i]=='管理员')releaseRoles+="["+100+"]";
                                if(this.releaseRoles[i]=='调研组员')releaseRoles+="["+50+"]";
                                if(this.releaseRoles[i]=='收集成员')releaseRoles+="["+1+"]";
                            }
                        }
                        this.dataForm.releaseRoles=releaseRoles;

                        let replayRoles="";
                        if(this.replayRoles.length>0){
                            for(let i=0;i<this.replayRoles.length;i++){
                                if(this.replayRoles[i]=='管理员')replayRoles+="["+100+"]";
                                if(this.replayRoles[i]=='调研组员')replayRoles+="["+50+"]";
                                if(this.replayRoles[i]=='收集成员')replayRoles+="["+1+"]";
                            }
                        }
                        this.dataForm.replayRoles=replayRoles;


                        let seeRoles="";
                        if(this.seeRoles.length>0){
                            for(let i=0;i<this.seeRoles.length;i++){
                                if(this.seeRoles[i]=='管理员')seeRoles+="["+100+"]";
                                if(this.seeRoles[i]=='调研组员')seeRoles+="["+50+"]";
                                if(this.seeRoles[i]=='收集成员')seeRoles+="["+1+"]";
                            }
                        }
                        this.dataForm.seeRoles=seeRoles;

                        admin_type_save(this.dataForm).then((res) => {
                            dealResult(res.data);
                            if (res.data.status == 1) {
                                this.editVisible = false;
                                this.managerIndex=-1;
                                this.getPage();
                            }

                        })
                    }
                })
            },

            //删除操作
            handleDelete(index, row) {

                // 二次确认删除
                this.$confirm("确定要删除' "+row.name+" '吗？", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        admin_type_del({id: row.id, uid: this.lander.uid, token: this.lander.token}).then((res) => {
                            if (res.data.status == 1) {
                                dealResult(res.data);


                                this.$message.success("已删除成功");
                                //this.tableData.splice(index, 1);
                                this.managerIndex=-1;
                                this.getPage();


                            } else {
                                this.$notify({
                                    title: '提示',
                                    message: res.data.msg,
                                    duration: 2000
                                });
                            }

                        })

                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });


            },

            //获取列表数据
            getPage() {
                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;



                admin_type_page(this.query).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.tableData = res.data.obj.list
                        this.pageTotal = res.data.obj.total//该页总共多少条记录

                        //更新调研组员弹出框

                       if(this.managerIndex>-1) this.handleSetManager(this.managerIndex,this.tableData[this.managerIndex]);

                    }

                })
            },


            //获取列表数据
            getUTPage() {
                this.utQuery.uid = this.lander.uid;
                this.utQuery.token = this.lander.token;
                this.utQuery.typeId = this.managerForm.id;

                if(this.utQuery.typeId=='sub'){
                    this.utQuery.isAgree='1';
                }

                admin_getUTPage(this.utQuery).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.utli = res.data.obj.list
                        this.utTotal = res.data.obj.total//该页总共多少条记录
                    }

                })
            },

        },
        mounted() {
            this.lander = JSON.parse(this.$store.state.logininfo);
            //去后端查询所有的用户给tableData赋值

            this.FILE_ACTION=process.env.VUE_APP_API_ROOT+'/common/upimg?type=type_icon&uid='+this.lander.uid+"&token="+this.lander.token;


            if(this.$route.query.type!=undefined) {
                if( this.lander.role=='100') this.query.type=this.$route.query.type;
                else this.query.type='sub';
            }else{
                if( this.lander.role=='100')this.query.type='forum';
                else this.query.type='sub';
            }
            this.query.pageNo=1;
            this.tableData=[];
            this.getPage();

            this.managerIndex=-1;//切换页面莫名弹框
        },
        watch:{
            $route:function(value){
                if(this.$route.query.type!=undefined) {
                    if( this.lander.role=='100') this.query.type=value.query.type;
                    else this.query.type='sub';
                }else{
                    if( this.lander.role=='100')this.query.type='forum';
                    else this.query.type='sub';
                }
                this.query.pageNo=1;
                this.tableData=[];
                this.getPage();

                this.managerIndex=-1;//切换页面莫名弹框

            }
        },
    }
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
        width: 150px;
    }

    /*滚动条的宽度*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 10px;
    }

    /*滚动条滑块*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background-color: #409eff;
        /*border-radius: 3px;*/
    }

    .el-card ::v-deep .el-card__header {

        background-color: #dddddd;
    }

</style>
